module.exports = __webpack_public_path__ + "media/components/src/assets/images/back-arrow/back-arrow-5029da97296102b6813a2c0b3d19845d.png";